var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLuckyWheel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-label": "Soru \\xC7ark\\u0131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "qw-face",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EC3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B51C28"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "qw-inner",
    cx: 0.42,
    cy: 0.3,
    r: 0.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3202C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qw-gloss",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qw-rim",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE98A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F5B91F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C98207"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "qw-hub",
    cx: 0.4,
    cy: 0.3,
    r: 0.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DEE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "qw-shade",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#000000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000",
    stopOpacity: 0.18
  })), /*#__PURE__*/React.createElement("filter", {
    id: "qw-bsh",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "qw-osh",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "170%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 8,
    floodColor: "#4A0008",
    floodOpacity: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qw-clip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.0,44.0 A46.3,46.3 0 0 1 337.1,60.1 A46.3,46.3 0 0 1 405.9,106.1 A46.3,46.3 0 0 1 451.9,174.9 A46.3,46.3 0 0 1 468.0,256.0 A46.3,46.3 0 0 1 451.9,337.1 A46.3,46.3 0 0 1 405.9,405.9 A46.3,46.3 0 0 1 337.1,451.9 A46.3,46.3 0 0 1 256.0,468.0 A46.3,46.3 0 0 1 174.9,451.9 A46.3,46.3 0 0 1 106.1,405.9 A46.3,46.3 0 0 1 60.1,337.1 A46.3,46.3 0 0 1 44.0,256.0 A46.3,46.3 0 0 1 60.1,174.9 A46.3,46.3 0 0 1 106.1,106.1 A46.3,46.3 0 0 1 174.9,60.1 A46.3,46.3 0 0 1 256.0,44.0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(256 250) scale(0.9) translate(-256 -256)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 16)",
    fill: "#4A0008",
    opacity: 0.38,
    filter: "url(#qw-bsh)",
    d: "M256.0,44.0 A46.3,46.3 0 0 1 337.1,60.1 A46.3,46.3 0 0 1 405.9,106.1 A46.3,46.3 0 0 1 451.9,174.9 A46.3,46.3 0 0 1 468.0,256.0 A46.3,46.3 0 0 1 451.9,337.1 A46.3,46.3 0 0 1 405.9,405.9 A46.3,46.3 0 0 1 337.1,451.9 A46.3,46.3 0 0 1 256.0,468.0 A46.3,46.3 0 0 1 174.9,451.9 A46.3,46.3 0 0 1 106.1,405.9 A46.3,46.3 0 0 1 60.1,337.1 A46.3,46.3 0 0 1 44.0,256.0 A46.3,46.3 0 0 1 60.1,174.9 A46.3,46.3 0 0 1 106.1,106.1 A46.3,46.3 0 0 1 174.9,60.1 A46.3,46.3 0 0 1 256.0,44.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 8)",
    fill: "#8C121D",
    d: "M256.0,44.0 A46.3,46.3 0 0 1 337.1,60.1 A46.3,46.3 0 0 1 405.9,106.1 A46.3,46.3 0 0 1 451.9,174.9 A46.3,46.3 0 0 1 468.0,256.0 A46.3,46.3 0 0 1 451.9,337.1 A46.3,46.3 0 0 1 405.9,405.9 A46.3,46.3 0 0 1 337.1,451.9 A46.3,46.3 0 0 1 256.0,468.0 A46.3,46.3 0 0 1 174.9,451.9 A46.3,46.3 0 0 1 106.1,405.9 A46.3,46.3 0 0 1 60.1,337.1 A46.3,46.3 0 0 1 44.0,256.0 A46.3,46.3 0 0 1 60.1,174.9 A46.3,46.3 0 0 1 106.1,106.1 A46.3,46.3 0 0 1 174.9,60.1 A46.3,46.3 0 0 1 256.0,44.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#qw-face)",
    d: "M256.0,44.0 A46.3,46.3 0 0 1 337.1,60.1 A46.3,46.3 0 0 1 405.9,106.1 A46.3,46.3 0 0 1 451.9,174.9 A46.3,46.3 0 0 1 468.0,256.0 A46.3,46.3 0 0 1 451.9,337.1 A46.3,46.3 0 0 1 405.9,405.9 A46.3,46.3 0 0 1 337.1,451.9 A46.3,46.3 0 0 1 256.0,468.0 A46.3,46.3 0 0 1 174.9,451.9 A46.3,46.3 0 0 1 106.1,405.9 A46.3,46.3 0 0 1 60.1,337.1 A46.3,46.3 0 0 1 44.0,256.0 A46.3,46.3 0 0 1 60.1,174.9 A46.3,46.3 0 0 1 106.1,106.1 A46.3,46.3 0 0 1 174.9,60.1 A46.3,46.3 0 0 1 256.0,44.0 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 178,
    fill: "#8C121D",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 252,
    r: 174,
    fill: "url(#qw-inner)",
    stroke: "#FFFFFF",
    strokeOpacity: 0.5,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qw-clip)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 118,
    rx: 210,
    ry: 112,
    fill: "url(#qw-gloss)",
    opacity: 0.55
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#qw-osh)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 276,
    r: 142,
    fill: "#8A5A04"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 268,
    r: 142,
    fill: "url(#qw-rim)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,268 L210.8,159.0 A118,118 0 0 1 301.2,159.0 Z",
    fill: "#FFC23A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,268 L301.2,159.0 A118,118 0 0 1 365.0,222.8 Z",
    fill: "#2FCB7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,268 L365.0,222.8 A118,118 0 0 1 365.0,313.2 Z",
    fill: "#3AA2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,268 L365.0,313.2 A118,118 0 0 1 301.2,377.0 Z",
    fill: "#7B3FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,268 L301.2,377.0 A118,118 0 0 1 210.8,377.0 Z",
    fill: "#FF6FA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,268 L210.8,377.0 A118,118 0 0 1 147.0,313.2 Z",
    fill: "#FF8A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,268 L147.0,313.2 A118,118 0 0 1 147.0,222.8 Z",
    fill: "#17B3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,268 L147.0,222.8 A118,118 0 0 1 210.8,159.0 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 268,
    r: 118,
    fill: "url(#qw-shade)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,208 A110,110 0 0 1 236,160",
    fill: "none",
    stroke: "#FFFFFF",
    strokeOpacity: 0.6,
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF8D6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 138,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.7,
    cy: 147.9,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.9,
    cy: 176.1,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.1,
    cy: 218.3,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 268,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.1,
    cy: 317.7,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.9,
    cy: 359.9,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.7,
    cy: 388.1,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 398,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.3,
    cy: 388.1,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.1,
    cy: 359.9,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.9,
    cy: 317.7,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 268,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.9,
    cy: 218.3,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.1,
    cy: 176.1,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.3,
    cy: 147.9,
    r: 5
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 272,
    r: 24,
    fill: "#8A5A04"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 268,
    r: 24,
    fill: "url(#qw-hub)",
    stroke: "#F5B91F",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 280,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 32,
    fill: "#C3202C"
  }, "?"), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 5)",
    d: "M256,160 L232,118 Q256,100 280,118 Z",
    fill: "#1A1E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,160 L232,118 Q256,100 280,118 Z",
    fill: "#2F3448",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 116,
    rx: 10,
    ry: 5,
    fill: "#FFFFFF",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(388 150) scale(16)",
    fill: "#FFFFFF",
    d: "M0,-1 C0.12,-0.12 0.12,-0.12 1,0 C0.12,0.12 0.12,0.12 0,1 C-0.12,0.12 -0.12,0.12 -1,0 C-0.12,-0.12 -0.12,-0.12 0,-1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(120 160) scale(10)",
    fill: "#FFFFFF",
    opacity: 0.85,
    d: "M0,-1 C0.12,-0.12 0.12,-0.12 1,0 C0.12,0.12 0.12,0.12 0,1 C-0.12,0.12 -0.12,0.12 -1,0 C-0.12,-0.12 -0.12,-0.12 0,-1 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuckyWheel);
export default __webpack_public_path__ + "static/media/lucky-wheel.0c123876be7fb45f11503f3d628b014a.svg";
export { ForwardRef as ReactComponent };